// Dependencies
import { createUserManager } from 'redux-oidc';

// Helpers
import { getEnvironmentVariable } from 'helpers/environmentVariableHelpers.js';
import { getServerDate } from 'helpers/serverHelpers';

const configIsLoaded = () => {
  return new Promise((resolve, reject) => {
    if (getEnvironmentVariable('oidc_client_id', null, true)) {
      const userManagerConfig = {
        client_id: getEnvironmentVariable('oidc_client_id', null, true),
        authority: getEnvironmentVariable('oidc_authority'),
        redirect_uri: getEnvironmentVariable('oidc_redirect_uri'),
        post_logout_redirect_uri: getEnvironmentVariable('oidc_post_logout_redirect_uri'),
        silent_redirect_uri: getEnvironmentVariable('oidc_silent_redirect_uri'),
        response_type: "code",
        scope: "openid profile",
        acr_values: "idporten-loa-substantial",
        ui_locales: "nb",
        resource: getEnvironmentVariable('oidc_resource'),
        loadUserInfo: false,
        revokeAccessTokenOnSignout: true,
        // Forny tokenet proaktivt via silent-refresh.html før det utløper (i tillegg til den
        // reaktive 401-fornyelsen i apiClient), så økten ikke faller ut midt i redigering.
        automaticSilentRenew: true,
        accessTokenExpiringNotificationTime: 60,
        clockService: {
          getEpochTime: getServerDate
        }
      }
      resolve(userManagerConfig);
    } else {
      window.setTimeout(() => {
        resolve(configIsLoaded());
      }, 100)
    }
  });
}
const getUserManagerConfigWhenReady = configIsLoaded().then((userManagerConfig) => {
  return createUserManager(userManagerConfig);
})

export default getUserManagerConfigWhenReady;
